import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { apiJson } from "../lib/api_errore"

// WorthItDialog di pages/ProjectDetail.js:40-102 (31a5bd1). «Vale la pena?» di una riga apre la finestra con
// «{bando} · {progetto}» e l'attesa, poi POST /app/progetto/:id/worth-it { grant_id }; riuscita, legge lo stato
// (GET /api/projects/:id/worth-it-status) ogni 3 s, al più 60 volte (pollAnalysisJob): «done» carica il risultato nel
// turbo-frame "worth-it-risultato", «error» o il tempo scaduto danno il toast «Valutazione non riuscita, riprova.».
// Una POST rifiutata: il toast della risposta (Turbo Stream) e l'attesa resta, come l'originale. Chiudere la finestra
// ferma la lettura dello stato.
const INTERVALLO = 3000
const TENTATIVI = 60

export default class extends Controller {
  static targets = ["titolo", "attesa", "risultato"]
  static values = { url: String, stato: String, risultato: String, progetto: String }

  disconnect() {
    this.ferma()
  }

  async apri({ params: { grant, nome } }) {
    this.ferma()
    const giro = (this.giro = {})
    this.titoloTarget.textContent = `${nome} · ${this.progettoValue}`
    this.attesaTarget.hidden = false
    this.risultatoTarget.removeAttribute("src")
    this.risultatoTarget.innerHTML = ""
    window.dispatchEvent(new CustomEvent("dialog:open", { detail: { id: "worth-it-dialog" } }))
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    let res
    try {
      res = await fetch(this.urlValue, {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "text/vnd.turbo-stream.html", ...(token ? { "X-CSRF-Token": token } : {}) },
        body: JSON.stringify({ grant_id: grant }),
      })
    } catch {
      window.toast?.error("Si è verificato un errore. Riprova.")
      return
    }
    if (giro !== this.giro) return
    if (!res.ok) {
      Turbo.renderStreamMessage(await res.text())
      return
    }
    this.leggi(giro, grant, 0)
  }

  leggi(giro, grant, tentativi) {
    this.timer = setTimeout(async () => {
      if (giro !== this.giro) return
      tentativi += 1
      try {
        const data = await apiJson(this.statoValue)
        if (giro !== this.giro) return
        if (data.status === "done") return this.mostra(grant)
        if (data.status === "error") return this.errore()
      } catch {
        // errore transitorio di rete o del proxy: si continua fino ai tentativi massimi
      }
      if (giro !== this.giro) return
      if (tentativi >= TENTATIVI) return this.errore()
      this.leggi(giro, grant, tentativi)
    }, INTERVALLO)
  }

  mostra(grant) {
    this.attesaTarget.hidden = true
    this.risultatoTarget.src = `${this.risultatoValue}?grant_id=${encodeURIComponent(grant)}`
  }

  errore() {
    window.toast?.error("Valutazione non riuscita, riprova.")
  }

  // la finestra chiusa (dialog:closed): nessuna lettura dello stato dopo
  chiusa() {
    this.ferma()
  }

  ferma() {
    this.giro = null
    clearTimeout(this.timer)
  }
}
